// Mock fixtures for the Leg Planning (Legs) prototype. FE-only — no API.
// Numbers/names mirror the design mock so the layout reads true.

export type LegStatus = 'Planned' | 'Assigned' | 'En Route' | 'Delivered' | 'Unassigned' | 'At Risk';

export type LegType =
  | 'Collection'
  | 'Delivery'
  | 'Trunk/Drayage'
  | 'Reposition'
  | 'Yard Check'
  | 'Vehicle Service'
  | 'Shunt'
  | 'Equipment Run';

/** Direction grouping bucket + the chip label/flow shown in the Direction column. */
export type DirectionFlow = 'out' | 'in' | 'local';

export type FitTone = 'ok' | 'warn' | 'risk';

export interface Leg {
  id: string;
  window: string | null; // "06:00–08:00"
  type: LegType;
  ref: string | null;
  from: string;
  to: string;
  distDur: string | null;
  flow: DirectionFlow;
  directionLabel: string; // "Local" | "Dublin Port"
  asset: string | null;
  driver: string | null;
  status: LegStatus;
  fit: string;
  fitTone: FitTone;
}

export const LEGS: Leg[] = [
  { id: 'L-501', window: '06:00–08:00', type: 'Collection', ref: '2604-0114', from: 'Dublin Depot', to: 'Castleblayney', distDur: '52km · 1h 20m', flow: 'local', directionLabel: 'Local', asset: 'Full Load · GDP · 18 plt', driver: 'Peter Szobo', status: 'Planned', fit: 'On plan', fitTone: 'ok' },
  { id: 'L-502', window: '07:00–08:00', type: 'Collection', ref: '310017', from: 'Dublin Depot', to: 'Pfizer Ringaskiddy', distDur: '42km · 1h', flow: 'local', directionLabel: 'Local', asset: 'GDP Refrig · ADR', driver: 'Dan Crowley', status: 'Planned', fit: 'On plan', fitTone: 'ok' },
  { id: 'L-510', window: '07:00–09:30', type: 'Delivery', ref: '324963', from: 'Dublin Depot', to: 'Binochem', distDur: '35km · 55m', flow: 'local', directionLabel: 'Local', asset: 'GDP Refrig', driver: 'Marcin Zabor', status: 'Delivered', fit: 'On plan', fitTone: 'ok' },
  { id: 'L-504', window: '08:00–09:30', type: 'Trunk/Drayage', ref: '2604-0114', from: 'Castleblayney', to: 'Dublin Port', distDur: '120km · 1h 30m', flow: 'out', directionLabel: 'Dublin Port', asset: 'Full Load · GDP', driver: 'Peter Szobo', status: 'Planned', fit: 'Ferry 13:45 — comfortable', fitTone: 'ok' },
  { id: 'L-503b', window: '08:00–09:30', type: 'Delivery', ref: '310017', from: 'Pfizer Ringaskiddy', to: 'SCL Pharma', distDur: '18km · 45m', flow: 'local', directionLabel: 'Local', asset: 'GDP Refrig · ADR', driver: 'Dan Crowley', status: 'Planned', fit: 'On plan', fitTone: 'ok' },
  { id: 'L-505', window: '08:00–12:00', type: 'Collection', ref: '2604-0110', from: 'Dublin Depot', to: 'Roscrea', distDur: '110km · 2h', flow: 'local', directionLabel: 'Local', asset: 'GDP Refrig', driver: 'A. Healy', status: 'En Route', fit: 'On plan', fitTone: 'ok' },
  { id: 'L-506', window: '09:30–13:30', type: 'Trunk/Drayage', ref: '2604-0114', from: 'Dublin Port (ferry)', to: 'Holyhead', distDur: '— · 4h', flow: 'out', directionLabel: 'Dublin Port', asset: 'Full Load · GDP', driver: 'Peter Szobo', status: 'Planned', fit: 'On ferry', fitTone: 'ok' },
  { id: 'L-507', window: '09:30–10:15', type: 'Reposition', ref: null, from: 'SCL Pharma', to: 'Dublin Depot', distDur: '28km · 45m', flow: 'local', directionLabel: 'Local', asset: null, driver: 'Dan Crowley', status: 'Assigned', fit: 'Deadhead 45m', fitTone: 'ok' },
  { id: 'L-508', window: '09:30–10:00', type: 'Yard Check', ref: null, from: 'Binochem', to: 'Dublin Depot Yard', distDur: '35km · 30m', flow: 'local', directionLabel: 'Local', asset: null, driver: 'Marcin Zabor', status: 'Assigned', fit: 'On plan', fitTone: 'ok' },
  { id: 'L-509', window: '10:15–11:00', type: 'Vehicle Service', ref: null, from: 'Dublin Depot', to: 'North City Tyres', distDur: '8km · 45m', flow: 'local', directionLabel: 'Local', asset: 'Truck 191C6234', driver: 'Dan Crowley', status: 'Assigned', fit: 'Fits before tacho limit', fitTone: 'ok' },
  { id: 'L-511', window: '12:00–16:00', type: 'Delivery', ref: '2604-0110', from: 'Roscrea', to: 'Dublin Depot', distDur: '110km · 2h', flow: 'local', directionLabel: 'Local', asset: 'GDP Refrig', driver: 'A. Healy', status: 'Planned', fit: 'Tight — 6.5h tacho remaining', fitTone: 'warn' },
  { id: 'L-512', window: '13:30–14:00', type: 'Shunt', ref: null, from: 'Holyhead Port', to: 'Yard — Bay 4', distDur: '2km · 30m', flow: 'local', directionLabel: 'Local', asset: 'Trailer T-2891', driver: 'Peter Szobo', status: 'Assigned', fit: 'Fits end of day', fitTone: 'ok' },
  { id: 'L-513', window: null, type: 'Shunt', ref: null, from: 'Dublin Port Yard', to: 'Yard — Bay 7', distDur: '5km · 30m', flow: 'in', directionLabel: 'Dublin Port', asset: 'Trailer T-3350', driver: null, status: 'Unassigned', fit: 'Fits Doody — full availability', fitTone: 'ok' },
  { id: 'L-514', window: null, type: 'Equipment Run', ref: null, from: 'Dublin Depot', to: 'Cork Depot', distDur: '260km · 4h', flow: 'local', directionLabel: 'Local', asset: 'Pallet jacks ×4', driver: null, status: 'Unassigned', fit: 'No driver with 4h free', fitTone: 'warn' },
  { id: 'L-503', window: null, type: 'Trunk/Drayage', ref: '309711', from: 'Dublin Port', to: 'Dublin Depot', distDur: '18km · 1h 15m', flow: 'in', directionLabel: 'Dublin Port', asset: 'Inbound container', driver: null, status: 'At Risk', fit: 'SLA tightening — assign now', fitTone: 'risk' },
];

// ── Filters ─────────────────────────────────────────────────────────────────

export const LEG_FILTERS = ['All', 'Unassigned', 'At Risk', 'In Progress', 'Planned', 'Delivered'] as const;
export type LegFilter = (typeof LEG_FILTERS)[number];

export function matchesFilter(l: Leg, f: LegFilter): boolean {
  switch (f) {
    case 'All':
      return true;
    case 'Unassigned':
      return l.driver === null;
    case 'At Risk':
      return l.status === 'At Risk';
    case 'In Progress':
      return l.status === 'En Route';
    case 'Planned':
      return l.status === 'Planned';
    case 'Delivered':
      return l.status === 'Delivered';
  }
}

export type GroupMode = 'Flat' | 'Driver' | 'Direction';

export const DIRECTION_SECTIONS: { flow: DirectionFlow; label: string }[] = [
  { flow: 'out', label: 'Outbound — to port' },
  { flow: 'in', label: 'Inbound — from port' },
  { flow: 'local', label: 'Local / Depot' },
];

// ── Drivers ─────────────────────────────────────────────────────────────────

export interface RosterDriver {
  id: string;
  name: string;
  reg: string;
  startLabel: string; // "06:00 · Dublin"
  tachoHours: number;
  tachoMax: number;
  /** Estimated drive time left in the shift (hours); null = no tacho data yet. */
  driveRemainingH: number | null;
  /** Estimate shown when drive time is unknown ("Est. from plan — Xh"). */
  estFromPlanH?: number;
  capabilities: string[];
  onTimePct: number;
  lastLocation?: string;
  fit: boolean;
}

export const DRIVERS: RosterDriver[] = [
  { id: 'd1', name: 'Peter Szobo', reg: '241C7318', startLabel: '06:00 · Dublin', tachoHours: 5, tachoMax: 9, driveRemainingH: 3.8, capabilities: ['GDP', 'HAZ', 'ADR'], onTimePct: 91, lastLocation: 'Yard — Bay 4', fit: true },
  { id: 'd2', name: 'Dan Crowley', reg: '191C6234', startLabel: '07:00 · Dublin', tachoHours: 2.5, tachoMax: 9, driveRemainingH: 1.9, capabilities: ['GDP', 'ADR'], onTimePct: 89, lastLocation: 'North City Tyres', fit: true },
  { id: 'd3', name: 'A. Healy', reg: '211C6865', startLabel: '08:00 · Cork', tachoHours: 0, tachoMax: 9, driveRemainingH: 0.3, capabilities: ['GDP', 'TEMP'], onTimePct: 87, lastLocation: 'Dublin Depot', fit: true },
  { id: 'd4', name: 'James Doody', reg: '222C4712', startLabel: '05:00 · Dublin', tachoHours: 8.5, tachoMax: 9, driveRemainingH: null, estFromPlanH: 8.5, capabilities: ['ADR'], onTimePct: 84, fit: true },
  { id: 'd5', name: 'Marcin Zabor', reg: '251C105', startLabel: '07:00 · Dublin', tachoHours: 5, tachoMax: 9, driveRemainingH: 4.2, capabilities: ['GDP', 'FOOD'], onTimePct: 92, lastLocation: 'Dublin Depot Yard', fit: true },
  { id: 'd6', name: 'Shawn Lewis', reg: '191C123', startLabel: '07:00 · Dublin', tachoHours: 5, tachoMax: 9, driveRemainingH: 4.0, capabilities: ['GDP'], onTimePct: 88, fit: true },
];

// ── "my i" intelligence (derived from the selected leg) ──────────────────────

export interface FitDriver {
  name: string;
  detail: string;
}
export interface SlaCard {
  ref: string;
  title: string;
  body: string;
  action: string;
  tone: 'risk' | 'warn';
}
export interface LegIntel {
  contextLabel: string;
  slaCards: SlaCard[];
  fitDrivers: FitDriver[];
  feasibleNote: string | null;
  brief: string | null;
  capacityNote: string | null;
}

/** Build the my-i card stack for a selected leg (or a default when none). */
export function intelFor(leg: Leg | null): LegIntel {
  if (!leg) {
    return {
      contextLabel: 'Select a leg',
      slaCards: [],
      fitDrivers: [],
      feasibleNote: null,
      brief: 'Select a leg to evaluate it.',
      capacityNote: null,
    };
  }

  const unresolved = leg.driver === null || leg.status === 'At Risk' || leg.status === 'Unassigned';

  const slaCards: SlaCard[] = [];
  if (leg.status === 'At Risk') {
    slaCards.push({
      ref: leg.ref ?? leg.id,
      title: 'SLA at risk',
      body: 'SLA tightening — assign now. Immediate assignment required to avoid breach.',
      action: 'Assign now',
      tone: 'risk',
    });
  }
  if (unresolved) {
    slaCards.push({
      ref: leg.id,
      title: 'tacho constraint',
      body: 'SLA tightening — assign now',
      action: 'Review roster',
      tone: 'warn',
    });
  }

  return {
    contextLabel: `Dublin Depot · ${leg.id}`,
    slaCards,
    fitDrivers: unresolved
      ? [
          { name: 'Peter Szobo', detail: '5h avail · 91% on-time GDP' },
          { name: 'Dan Crowley', detail: '2.5h avail · 89% on-time GDP' },
        ]
      : [],
    feasibleNote: unresolved ? '2 drivers feasible for this leg.' : null,
    brief: leg.driver
      ? `${leg.driver} — ${leg.type} ${leg.from} → ${leg.to}${leg.window ? `, ${leg.window}` : ''}. ${leg.asset ?? ''}`.trim()
      : 'Assign a driver to generate brief.',
    capacityNote: unresolved ? 'James Doody — best available · Full shift · 8.5h tacho · ADR certified · Dublin.' : null,
  };
}
